export const tableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [{
      label: '状态',
      prop: 'status',
      width: 80,
    },
	  {
      label: '问卷预览',
      prop: 'name',
      solt: 'name',
      width: 260,
      overHidden: true,
      align: 'left',
    },
    // {
    //   label: '小程序二维码',
    //   prop: 'miniProgramCodeUrl',
    //   solt: true,
    //   width: 150,
    //   align: 'left',
    // },
    {
      label: '培训名称',
      prop: 'activityName',
      width: 150,
      overHidden: true,
    },
    {
      label: '项目名称',
      prop: 'projectName',
      width: 150,
      overHidden: true,
    },
    {
      label: '培训讲师',
      prop: 'projectLecturer',
      width: 150,
      overHidden: true,
    },
    {
      label: '开始时间',
      prop: 'startTime',
      width: 160,
      align: 'left',
    },
    {
      label: '结束时间',
      prop: 'endTime',
      width: 160,
      align: 'left',
    },
    {
      label: '参与人数',
      prop: 'participantCount',
      width: 100,
      overHidden: true,
      align: 'left',
    },
    {
      label: '总评分',
      prop: 'totalScore',
      width: 100,
      overHidden: true,
      align: 'left',
    },
    {
      label: '平均评分',
      prop: 'averageScore',
      width: 100,
      overHidden: true,
      align: 'left',
    },
    /* {
      label: '查看问卷结果',
      prop: 'viewAnswerResultType',
      width: 150,
      hide: true,
      overHidden: true,
    },
    {
      label: '问卷模式',
      prop: 'paperMode',
      hide: true,
    }, */
/*     {
      label: '是否匿名',
      prop: 'isAnonymous',
      width: 120,
      hide: true,
    },
    {
      label: '是否公开',
      prop: 'isPublic',
      width: 150,
      hide: true,
    }, */
    {
      label: '创建时间',
      prop: 'insertedTime',
      width: 160,
      align: 'left',
    },
  ]
}

export const answeredMemberListOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
    {
      label: '员工号',
      prop: 'unionId',
      overHidden: true,
    },
	  {
      label: 'Birth Name',
      prop: 'realname',
      overHidden: true,
    },
    {
      label: 'Full Name',
      prop: 'nickname',
      overHidden: true,
    },
    {
      label: '作答时间',
      prop: 'insertedTime',
      overHidden: true,
      sortable: true,
    },
  ]
}

export const publishOptions = [
  { label: '已上架', value: true },
  { label: '已下架', value: false },
]

export const viewAnswerResultTypeOptions = [
  { label: '参与问卷后可见', value: 1 },
  { label: '仅创建者自己可见', value: 2 },
  { label: '所有人可见', value: 3 },
]

export const paperModeOptions = [
  { label: '普通问卷', value: 1 },
  { label: '考试模式', value: 2 },
]

export const anonymousOptions = [
  { label: '是', value: 1 },
  { label: '否', value: 0 },
]

export const publicOptions = [
  { label: '是', value: 1 },
  { label: '否', value: 0 },
]

export const topicTypeOptions = [
  { label: '单选题', value: 1 },
  { label: '多选题', value: 2 },
  { label: '简答题', value: 3 },
  { label: '评分题', value: 4 },
]

export const checkTypeOptions = [
  { label: '无验证', value: 0 },
  { label: '非空', value: 1 },
  { label: '手机号', value: 2 },
  { label: '邮箱', value: 3 },
  { label: '姓名', value: 4 },
]